import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ROUTES } from '@app/router/constants';
import { NavItem, TabConfig } from '@app/components/HeaderNavigation/types';
import { getRouteLabel, getUserType, shouldShowFAQs } from '@app/components/HeaderNavigation/utils';
import { selectUser, selectUserInfo } from '@app/redux';
import { selectLocale } from '@app/redux/locale';

// Build navigation tabs
export const useBuildNavigationTabs = (TAB_CONFIG: TabConfig): NavItem[] => {
  const { t } = useTranslation('Nav');

  const {
    user: { productKind },
  } = useSelector(selectUser);

  const {
    locale: { userLocale },
  } = useSelector(selectLocale);

  const {
    userInfo: { accountType },
  } = useSelector(selectUserInfo);

  // Get base tabs based on user type
  const userType = getUserType(productKind);
  const baseTabs = TAB_CONFIG[userType];

  // Map base tabs to navigation tabs with labels
  const tabs: NavItem[] = baseTabs.map((tab) => ({
    label: getRouteLabel(tab.path, t),
    path: tab.path,
    testId: tab.testId,
  }));

  tabs.push({
    label: getRouteLabel(ROUTES.NETWORK, t),
    path: ROUTES.NETWORK,
    testId: 'Network',
  });

  if (shouldShowFAQs(userLocale, accountType)) {
    tabs.push({
      label: getRouteLabel(ROUTES.HELP, t),
      path: ROUTES.HELP,
      testId: 'Help',
    });
  }

  return tabs;
};
